export const GUARANTEE_DEFAULT_CHARGE = '0.00'
export const GUARANTEE_DEFAULT_RANKING_MULTIPLIER = '1.2000'

export interface ServicesGuaranteeSetting {
    service_id: number
    /** Whether eligible providers in this service may offer Trustoo Guaranteed */
    enabled: boolean
    /** Extra fee the consumer pays when Guaranteed is active, decimal(10,2) */
    charge: string
    /** Search engine score multiplier for Guaranteed providers, decimal(10,4) */
    ranking_multiplier: string
}
